var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "38897281-D077-44C5-95D1-FEDFE8F5582F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast",
    transform: "translate(-120.000000, -454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 442.000000)",
    id: "icon/ic-success"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#02BD70",
    cx: 10,
    cy: 10,
    r: 8.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,7.5 C7.5,7.03976271 7.12690396,6.66666667 6.66666667,6.66666667 C6.20642938,6.66666667 5.83333333,7.03976271 5.83333333,7.5 L5.83333333,10.8333333 C5.83333333,11.2935706 6.20642938,11.6666667 6.66666667,11.6666667 L13.3333333,11.6666667 C13.7935706,11.6666667 14.1666667,11.2935706 14.1666667,10.8333333 C14.1666667,10.373096 13.7935706,10 13.3333333,10 L7.5,10 L7.5,7.5 Z",
    id: "Path-2",
    fill: "#FFFFFF",
    transform: "translate(10.000000, 9.166667) rotate(-45.000000) translate(-10.000000, -9.166667) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.bfab03155bef20c233e1ef25547b64f2.svg";
export { ForwardRef as ReactComponent };